import type { QueryClient } from '@tanstack/react-query'
import {
  createRootRouteWithContext,
  Navigate,
  Outlet,
} from '@tanstack/react-router'

import { type AuthDataType } from '@repo/common/queries/auth'

export const Route = createRootRouteWithContext<{
  auth: AuthDataType
  queryClient: QueryClient
}>()({
  notFoundComponent: function NotFound() {
    return <Navigate to="/" />
  },
  component: Root,
})

function Root() {
  return (
    <>
      <Outlet />
    </>
  )
}
